import axios from "@/http";
import { handleGetRequestParams } from '@/common/js/util'

class AddServiceMaintenance {
  /* 增值服务维护列表 */
  static getAddServiceMaintenanceList(options) {
    let url = `/oa/api/extra/service/example/list?`;
    url += handleGetRequestParams(options)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 更新增值服务维护状态 */
  static postUpdateAddServiceMaintenanceStatus(id, data) {
    const url = `/oa/api/extra/service/example/update/status/${id}`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 新增增值服务 */
  static postAddAddServiceMaintenance(data) {
    const url = `/oa/api/extra/service/example/save`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 编辑增值服务 */
  static postModAddServiceMaintenance(id, data) {
    const url = `/oa/api/extra/service/example/update/${id}`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
}

export default AddServiceMaintenance